import React from "react";
import { useDrawerAnimation } from "../../../../shared/animation";
import { colors } from "../../../../shared/constants";
import { concatUrl } from "../../helpers";
import MenuBadge from "./MenuBadge";
import * as S from "./styles";
export var TelehealthDrawerContent = function TelehealthDrawerContent(_ref) {
  var e = _ref.active,
      t = _ref.telehealthCategories,
      a = _ref.root,
      r = _ref.onMenuItemClick,
      l = _ref.scheduleVirtualCareVisit,
      n = _ref.renderLinkAs;

  var o = function o(e) {
    r && r("Site nav (Desktop) - ".concat(e));
  },
      c = useDrawerAnimation(e);

  return React.createElement(React.Fragment, null, c(function (e, r) {
    return r ? React.createElement(S.DrawerPrimaryContent, {
      style: e,
      "data-testid": "desktop-menu-drawer-telehealth"
    }, React.createElement(React.Fragment, null, React.createElement(S.SubMenuTitle, null, "Telehealth"), React.createElement(S.ExitMenuLink, {
      href: concatUrl(l.url, a),
      as: n || void 0,
      onClick: function onClick() {
        return o(l.mixpanelLabel);
      }
    }, l.label)), React.createElement(S.SubMenuTitle, null, "What We Treat"), t.map(function (e, t) {
      return e.isEnabled ? React.createElement(React.Fragment, {
        key: "".concat(e.displayName, "-").concat(t)
      }, React.createElement(S.ExitMenuLink, {
        href: concatUrl(e.url, a),
        as: n || void 0,
        onClick: function onClick() {
          return o(e.mixpanelLabel);
        }
      }, e.displayName, e.badge ? React.createElement(MenuBadge, {
        text: e.badge,
        backgroundColor: colors.teal4
      }) : null)) : null;
    })) : null;
  }));
};